import onElementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElementExistRunOnce('.manual-task-show-page', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/manual-task-show-page');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- report failed page initialization
    }
  })();
});

onElementExistRunOnce('.manual-task-field-map', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/manual-task-field-maps');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- report failed page initialization
    }
  })();
});
